import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { AuthLayout } from "@/pages/Login";

export default function Recover() {
  const [f, setF] = useState({ email: "", full_name: "", account_number: "", contact_number: "", reason: "" });
  const [done, setDone] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const body = Object.fromEntries(Object.entries(f).map(([k, v]) => [k, v || null]));
      const { data } = await api.post("/auth/recovery-requests", body, { skipRefresh: true });
      setDone(data.message);
    } catch (ex) { toast.error(errMsg(ex)); } finally { setBusy(false); }
  };
  return (
    <AuthLayout title="Account recovery" subtitle="Lost access to your email and authenticator app">
      {done ? (
        <div className="space-y-4" data-testid="recovery-submitted">
          <p className="text-sm bg-emerald-50 border border-emerald-200 text-emerald-800 rounded-md p-3">{done}</p>
          <p className="text-sm text-slate-500">Staff will contact you to verify your identity (for example, valid ID at a CASURECO II office). No changes happen before verification.</p>
          <Link to="/login" className="text-amber-700 text-sm underline">Back to sign in</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="recovery-form">
          <div className="space-y-1.5"><Label>Registered email *</Label><Input type="email" required value={f.email} onChange={set("email")} data-testid="recovery-email-input" /></div>
          <div className="space-y-1.5"><Label>Full name *</Label><Input required value={f.full_name} onChange={set("full_name")} data-testid="recovery-name-input" /></div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-1.5"><Label>Account no. (optional)</Label><Input value={f.account_number} onChange={set("account_number")} data-testid="recovery-account-input" /></div>
            <div className="space-y-1.5"><Label>Contact no. (optional)</Label><Input value={f.contact_number} onChange={set("contact_number")} data-testid="recovery-contact-input" /></div>
          </div>
          <div className="space-y-1.5"><Label>What happened? *</Label><Textarea required minLength={10} value={f.reason} onChange={set("reason")} data-testid="recovery-reason-input" /></div>
          <Button type="submit" className="w-full" disabled={busy} data-testid="recovery-submit-button">Submit recovery request</Button>
          <Link to="/login" className="text-slate-500 text-sm hover:underline block">Back to sign in</Link>
        </form>
      )}
    </AuthLayout>
  );
}
